import React from 'react';
import { Chip } from '@mui/material';
import { BADGE_COLORS, getBadgeStyles } from '../../../../components/ui/badgeColors';

/**
 * Chip "Cliente final" de los envíos a cliente de contado. Mismo morado que el fondo
 * de la fila (FONDO_CLIENTE_FINAL): es una categoría, no un estado
 */
const ChipClienteFinal = ({ size = 'small' }) => (
    <Chip
        label="Cliente final"
        size={size}
        sx={{ ...getBadgeStyles(BADGE_COLORS.PURPLE, { height: 20, fontSize: 10 }), flexShrink: 0 }}
    />
);

export default ChipClienteFinal;
